import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppModule} from './app.module';
import { AppComponent } from './app.component';
import 'hammerjs';
import 'hammer-timejs';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    AppModule
  ],
  bootstrap: [AppComponent]
})
export class AppBrowserModule { }



// WEBPACK FOOTER //
// /opt/buildhome/repo/src/app/app.browser.module.ts